import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import MusicData, {MUSIC_TYPE_LOCAL, MUSIC_TYPE_USER} from "../../../Interfaces/MusicData";
import MusicListItem from "./MusicListItem";
import {addMusic, removeMusic, setCurrentMusic, setIsMusicPlaying, setMusicVolume} from "../../../store/makerDataSlice";
import ReactPlayer from "react-player";
import React, {useEffect, useRef, useState} from "react";
import {Button} from "react-bootstrap";
import {ErrorBoundary} from "../../Common/ErrorBoundary";
import uploadMusic from "../../../Api/uploadMusic";
import {useMutation} from "@tanstack/react-query";
import axios from "axios";
import * as Sentry from "@sentry/react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {SWAL_ALERT_DEFAULTS} from "../../../Utils/defaults";
import {UploadStatus} from "../../../Interfaces/SlideData";


interface MusicListProps {
}

const MusicList: React.FC<MusicListProps> = ({}) => {

    const MAX_SOUND_FILE_SIZE = 30; // Mb

    const fileInputRef = useRef<HTMLInputElement>(null);
    const musicPlayerRef = useRef<ReactPlayer>(null);

    const currentTab = useAppSelector(state => state.makerData.currentTab)
    const tmpProjectId = useAppSelector(state => state.makerData.tmpProjectId)
    const isMusicPlaying = useAppSelector(state => state.makerData.isMusicPlaying);
    const music = useAppSelector(state => state.makerData.music);
    const currentMusic = useAppSelector<MusicData>(state => state.makerData.currentMusic as MusicData);
    const makerData = useAppSelector(state => state.makerData);
    const dispatch = useAppDispatch()

    const mutationUploadMusic = useMutation({
        mutationFn: uploadMusic,
        onError: (error, variables, context) => {
            dispatch(addMusic({
                id: variables.pid,
                title1: variables.file.name,
                type: MUSIC_TYPE_USER,
                status: UploadStatus.uploadError,
                uploadError: 'Ошибка при загрузке'
            } as MusicData));
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to upload music. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: 'Ошибка',
                text: 'Ошибка при загрузке мелодии. Попробуйте загрузить ещё раз.',
                icon: 'error'
            });
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    const onClick = (data: MusicData) => {
        if (data.id == currentMusic.id) {
            dispatch(setIsMusicPlaying(!isMusicPlaying));
        } else {
            dispatch(setCurrentMusic(data));
            dispatch(setIsMusicPlaying(true));
        }
    }

    const onDelete = (data: MusicData) => {
        dispatch(removeMusic(data));
    }

    const uploadMusicFile = async (files: FileList | null) => {
        if (files?.length != 1) {
            return;
        }
        let file = files[0];

        mutationUploadMusic.mutate({
            file: file,
            dispatch: dispatch,
            tmpProjectId: tmpProjectId,
            pid: makerData.musicUploadPidOnlyOneFile, //uuidv4(),
            makerData: makerData
        });
    }

    return (
        <div className={'music-container'}>
            <div className={'music-player-sticky-empty'}></div>
            <div className={'music-player'}>
                {
                    (currentMusic?.url && currentMusic?.id) ?
                        <div className={'song-title'}>
                            {
                                currentMusic ?
                                    (
                                        <span>
                                    <b>{currentMusic.title1}</b>
                                            {
                                                currentMusic.title2 !== null && typeof currentMusic.title2 !== 'undefined' && currentMusic.title2.length > 0 ?
                                                    <span className="title2"> - {currentMusic.title2}</span>
                                                    : ''
                                            }
                                </span>
                                    ) : ''
                            }
                        </div> : ''
                }
                {
                    // Показываем плеер только если на вкладке "Музыка", а то при первоначальной загрузке сразу грузилась песня (4Мб)
                    // и манипуляции с preload: 'none', 'auto' не особо помогали
                    (currentMusic?.url && currentMusic?.id && currentTab == 'music') ?
                        <ReactPlayer
                            // key={currentMusic?.id}
                            ref={musicPlayerRef}
                            key={'music-tab-audio-player'}
                            url={currentMusic?.url}
                            playing={isMusicPlaying}
                            // volume={1}
                            loop={false}
                            width={'100%'}
                            height={'40px'}
                            config={{
                                file: {
                                    attributes: {
                                        preload: 'auto',
                                        controlsList: 'nodownload noplaybackrate',
                                    },
                                    forceAudio: true
                                }
                            }}
                            controls={true}
                            onPlay={() => {
                                dispatch(setIsMusicPlaying(true))
                            }}
                            onPause={() => {
                                dispatch(setIsMusicPlaying(false))
                            }}
                            onReady={() => {
                                try {
                                    musicPlayerRef?.current?.getInternalPlayer().addEventListener("volumechange", (event:any) => {
                                        if (event?.target?.volume) {
                                            dispatch(setMusicVolume(event?.target?.volume))
                                        }
                                    });
                                    if (musicPlayerRef?.current?.getInternalPlayer()) {
                                        // @ts-ignore
                                        musicPlayerRef?.current?.getInternalPlayer()?.volume = makerData.musicVolume;
                                    }
                                } catch (err) {
                                    // forgive
                                }
                            }}
                        />
                        : ''
                }
            </div>
            <h5 style={{'marginTop': 10}}>Загруженные мелодии</h5>
            <input
                type="file"
                id="uploadSoundInput"
                ref={fileInputRef}
                style={{display: 'none'}}
                accept=".mp3"
                onChange={e => {
                    e.stopPropagation();
                    if (e.target !== null && e.target.files !== null && e.target.files.length > 0) {
                        // @ts-ignore
                        const fileSize = e.target.files.item(0).size;
                        const fileMb = fileSize / 1024 ** 2;
                        if (fileMb < MAX_SOUND_FILE_SIZE) {
                            uploadMusicFile(e.target.files);
                        } else {
                            const MySwal = withReactContent(Swal)
                            MySwal.fire({
                                ...SWAL_ALERT_DEFAULTS,
                                title: '',
                                text: 'Слишком большой файл. Можно загрузить мелодию размером до 30Мб.',
                                icon: 'info'
                            });
                        }
                    }
                    e.currentTarget.value = '';
                }}
            />
            <Button
                className={'upload-sound-btn'}
                onClick={() => {
                    fileInputRef.current!.click();
                }}>
                Загрузить свою мелодию
            </Button>
            <div className={'music-list'}>
                {
                    music.filter(musicItemData => {
                        return musicItemData.type == MUSIC_TYPE_USER
                    }).reverse().map(musicItemData =>
                        <ErrorBoundary
                            place={'Music-MusicListItem'}
                            key={musicItemData.id}>
                            <MusicListItem
                                data={musicItemData}
                                isPlaying={musicItemData.id == currentMusic?.id ? isMusicPlaying : false}
                                onClick={onClick}
                                onDelete={onDelete}
                            />
                        </ErrorBoundary>
                    )
                }
            </div>

            <h5 style={{'marginTop': 20}}>Популярные мелодии</h5>
            <div className={'music-list popular'}>
                {
                    music.filter(musicItemData => {
                        return musicItemData.type == MUSIC_TYPE_LOCAL
                    }).map(musicItemData =>
                        <MusicListItem
                            key={musicItemData.id}
                            data={musicItemData}
                            isPlaying={musicItemData.id == currentMusic?.id ? isMusicPlaying : false}
                            onClick={onClick}
                            onDelete={onDelete}
                        />
                    )
                }
            </div>
        </div>
    )
}

export default MusicList;